<template>
  <div class="mt-2 mb-1">
    <b-form-textarea v-model="text" rows="3" class="mb-2" />
    <div>
      <b-button size="sm" variant="success" class="mr-1" @click="save">Сохранить</b-button>
      <b-button size="sm" variant="secondary" @click="$emit('cancel')">Отмена</b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'CommentEditForm',
  components: { BButton, BFormTextarea },
  props: { initialText: String },
  data() {
    return { text: this.initialText || '' }
  },
  methods: {
    save() {
      if (this.text.trim()) this.$emit('save', this.text)
    },
  },
}
</script>
